import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Tooltip,
  Button,
  Drawer,
  Popconfirm,
} from "antd";
import {
  OrderedListOutlined,
  RollbackOutlined,
  CheckCircleOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import FirmTransactionProjectTypeTableFilter from "../Filters/FirmTransactionProjectTypeTableFilter";
import CurrencyFormat from "react-currency-format";
import FirmTransactionProjectTypeAddForm from "../Forms/FirmTransactionProjectTypeAddForm";
import FirmTransactionProjectTypeUpdateForm from "../Forms/FirmTransactionProjectTypeUpdateForm";

const FirmTransactionProjectTypeByFirmList = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "PROJE DEPO LİSTESİ",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [firmName, setFirmName] = useState(props.match.params.firmName ?? "");
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});

  useEffect(
    () => getTableData(),
    [props.match.params.firmId, tableDataQueryOptions]
  );

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=name asc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/FirmTransactionProjectType/GetListByFirmId/${props.match.params.firmId}?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response,
        loading: false,
        total: response.length,
      });
    });
  };

  const handleOnClickUpdate = (record) => {
    setUpdateFormData(record);
    setUpdateFormVisibility(true);
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/FirmTransactionProjectType/${id}`).then(
      (response) => {
        if (response.success) {
          getTableData();
        }
      }
    );
  };

  const columns = [
    {
      title: "Depo Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text, record) => {
        if (!text) return "";

        const shortText =
          text.length <= 50 ? text : text.substring(0, 50) + "...";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Tooltip title={text}>{shortText}</Tooltip>
            {record.isMain && (
              <Tooltip title="Ana Depo">
                <CheckCircleOutlined style={{ color: "green" }} />
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      title: "Depo Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "center",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Proje Adı",
      dataIndex: "firmName",
      key: "firmName",
      align: "center",
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text?.substring(0, 20)?.length < 20
                ? text?.substring(0, 20) + ""
                : text?.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Depo Stok Listesi",
      dataIndex: "id",
      align: "center",
      key: "id",
      width: "9%",
      render: (text, record) => (
        <Link
          style={{ fontSize: "120%", color: "gray", paddingTop: 10 }}
          to={`/storage-stock/${record.transactionProjectTypeId}`}
        >
          <OrderedListOutlined />
        </Link>
      ),
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        tableData.total >= 1 ? (
          <a onClick={() => handleOnClickUpdate(row)}>
            <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
          </a>
        ) : null,
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(data)}
        >
          <a style={{ color: "red", fontSize: "130%" }}>
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const onAddTransactionProjectTypesuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  return (
    <>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={6} lg={5} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              setAddFormVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Depo Ekle
          </Button>
        </Col>
        <Col xs={24} md={6} lg={3} style={{ textAlign: "end", fontSize: 15 }}>
          <p style={{ fontWeight: "bold", color: "#2c3e50" }}>
            <span style={{ color: "#6f5196" }}>{firmName}</span>
          </p>
        </Col>
      </Row>
      <FirmTransactionProjectTypeTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>

      <Drawer
        id="addTransactionProjectTypeDrawer"
        title="Depo Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
        destroyOnClose={true}
      >
        <FirmTransactionProjectTypeAddForm
          onSuccess={onAddTransactionProjectTypesuccess}
          firmId={props.match.params.firmId}
          firmName={firmName}
        />
      </Drawer>
      <Drawer
        id="updateTransactionProjectTypeDrawer"
        title="Depo Düzenle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
        destroyOnClose={true}
      >
        <FirmTransactionProjectTypeUpdateForm
          onSuccess={() => {
            getTableData();
            setUpdateFormVisibility(false);
          }}
          data={updateFormData}
        />
      </Drawer>
    </>
  );
};

export default FirmTransactionProjectTypeByFirmList;
